import { FILTER_TYPE } from "utils/constants";
import { useEffect, useRef, useState } from "react";

export const TEST_RATE_COLUMNS_DATA = ({
  toggleSelectRow,
  toggleSelectAll,
  selectedRows,
  editableRows,
  setEditableRows,
  data,
  rate,
  mrp,
  mrpPercentage,
  ratePercentage,
  isSuperFranchise,
  isFranchise,
  isSubFranchise,
  // error,
  // setError,
}) => {

  const columns = [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
    },
    {
      Header: "Id",
      accessor: "id",
      disableSortBy: true,
    },
    {
      Header: "Test Name",
      accessor: "test_name",
      disableSortBy: true,
    },
    {
      Header: "Test Code",
      accessor: "test_code",
      disableSortBy: true,
    },
    {
      Header: "Status",
      accessor: "status",
      disableSortBy: true,
    },
    // {
    //   Header: "MRP Rate",
    //   accessor: "mrp_rate",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const [localMRPRate, setLocalMRPRate] = useState(
    //       row.original.mrp_rate || ""
    //     );
    //     const hasAppliedPercentage = useRef(false);

    //     useEffect(() => {
    //       if (editableRows[row.original.id]) {
    //         if (mrp) {
    //           setLocalMRPRate(mrp);
    //           row.original.mrp_rate = mrp;
    //           hasAppliedPercentage.current = false;
    //         } else if (mrpPercentage && !hasAppliedPercentage.current) {
    //           const originalMRPRate = parseFloat(row.original.mrp_rate) || 0;
    //           const percentageIncrease = (originalMRPRate * mrpPercentage) / 100;
    //           const adjustedMRP = originalMRPRate + percentageIncrease;
    //           setLocalMRPRate(adjustedMRP);
    //           row.original.mrp_rate = adjustedMRP;
    //           hasAppliedPercentage.current = true;
    //         }
    //       }
    //     }, [mrp, mrpPercentage, editableRows, row.original.id]);

    //     const handleMRPChange = (e) => {
    //       const value = e.target.value;
    //       setLocalMRPRate(value);
    //     };

    //     const handleBlur = () => {
    //       row.original.mrp_rate = parseFloat(localMRPRate) || 0;
    //     };

    //     return editableRows[row.original.id] ? (
    //       <input
    //         style={{ width: "100px", height: "25px", padding: "6px 12px" }}
    //         type="number"
    //         value={localMRPRate}
    //         onChange={handleMRPChange}
    //         onBlur={handleBlur}
    //         onFocus={(e) => e.target.select()}
    //       />
    //     ) : (
    //       localMRPRate
    //     );
    //   },
    // },
    {
      Header: "MRP Rate",
      accessor: "mrp_rate",
      disableSortBy: true,
    },
    {
      Header: "Test Rate",
      accessor: "rate",
      disableSortBy: true,
    },
    {
      Header: (
        <input
          type="checkbox"
          onChange={(e) => toggleSelectAll(e.target.checked)}
          checked={selectedRows.length === data.length && data.length > 0}
          indeterminate={
            selectedRows.length > 0 && selectedRows.length < data.length
              ? true
              : undefined
          }
        />
      ),
      accessor: "_select",
      disableSortBy: true,
      Cell: ({ row }) => (
        <input
          type="checkbox"
          onChange={() => toggleSelectRow(row.original.id)}
          checked={selectedRows.includes(row.original.id)}
        />
      ),
    },
  ];
  if (isSuperFranchise == 1 || isFranchise == 1) {
    const testRateIndex = columns.findIndex(
      (column) => column.accessor === "rate"
    );

    if (testRateIndex !== -1) {
      columns.splice(testRateIndex, 0, {
        Header: "Rate",
        accessor: "rates",
        disableSortBy: true,
      });
    }
  }

  return columns;
};

export const TEST_RATE_FORM_CONFIG = (rowData) => [
  {
    label: "Test Code",
    type: "input-text",
    name: "test_code",
    defaultValue: rowData?.test_code || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Name",
    type: "input-text",
    name: "test_name",
    defaultValue: rowData?.test_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Rate",
    type: "input-text",
    name: "rate",
    defaultValue: rowData?.rate || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test MRP Rate",
    type: "input-text",
    name: "mrp_rate",
    defaultValue: rowData?.mrp_rate || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: rowData?.zone_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Frachise Type",
    type: "select",
    name: "franchise_type",
    defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Frachise",
    type: "select",
    name: "franchise_dropdown",
    defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "Investigation Name",
    type: "select",
    name: "investigation_name",
    defaultValue: rowData?.investigation_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [{ key: "test_name", value: "Test Name" }];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "Inactive" },
];

export const BILLING_OPTIONS = [
  { key: "", value: "Select Billing Category" },
  { key: "Routine", value: "Routine" },
  { key: "Special", value: "Special" },
];
export const FILTER_DEFINITIONS = [
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
  {
    name: "billing_category",
    type: FILTER_TYPE.SELECT,
    initialValue: BILLING_OPTIONS[0].key,
  },
];
